import {
  FETCH_DUPLICATE_TEMPLATE_REQUEST,
  FETCH_DUPLICATE_TEMPLATE_SUCCESS,
  FETCH_DUPLICATE_TEMPLATE_FALUIRE,
} from './duplicateTemplateTypes'

const initialState = {
  loading: false,
  duplicatedTemplateInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_DUPLICATE_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DUPLICATE_TEMPLATE_SUCCESS : return {
      ...state,
      duplicatedTemplateInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DUPLICATE_TEMPLATE_FALUIRE : return {
      ...state,
      loading: false,
      duplicatedTemplateInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
